<div class="box box-info" [ngStyle]="{borderTop:'2px solid #f35309'}">

    <!-- cabesalho -->
    <div class="box-header with-border" style="height: 50px;">

      <h3 class="box-title" style="font-weight: 400;"><i class="{{boxIcon}}"></i>&nbsp;{{boxTitle}}</h3>

      <div class="box-tools pull-right" style="margin-bottom: 5px;">
          <ng-content select=".ng-box-header"></ng-content>
      </div>

    </div>

    <!-- corpo -->
    <div class="box-body">

        <ng-content select=".ng-box-content"></ng-content>
    
    </div>
    
    <div class="box-footer" *ngIf="showBoxFooter">

        <ng-content select=".ng-box-footer"></ng-content>
    
    </div>

</div>